import { Link, useNavigate, useParams, useLoaderData } from "react-router-dom";
import { useState, useEffect } from "react";

import { OpcionesEstadosTratamientos } from '../components/OpcionesEstadosTratamientos';

import { EntrenamientoUpdate } from "./EntrenamientoUpdate";
import { EntrenamientoDelete } from "./EntrenamientoDelete";

export function EntrenamientoEdit(props) {
  const entrenamiento = useLoaderData();
  const navigate = useNavigate();
  const errorMessage = entrenamiento.message;

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);


  const [entrResp, setEntrResp] = useState(entrenamiento.meta?.entrResp);
  const [entrFecha, setEntrFecha] = useState(entrenamiento.meta?.metaFecha);
  const [entrNumses, setEntrNumses] = useState(entrenamiento.meta?.entrNumses);
  const [entrMedio, setEntrMedio] = useState(entrenamiento.meta?.entrMedio);

  const [entrHipertenRad, setEntrHipertenRad] = useState(
    entrenamiento.meta?.entrHipertenRad
  );
  const [entrHiperlidRad, setEntrHiperlidRad] = useState(
    entrenamiento.meta?.entrHiperlidRad
  );
  const [entrHiperglucRad, setEntrHiperglucRad] = useState(
    entrenamiento.meta?.entrHiperglucRad
  );

  const [entrHistfamRad, setEntrHistfamRad] = useState(
    entrenamiento.meta?.entrHistfamRad
  );
  const [entrTabaqRad, setEntrTabaqRad] = useState(
    entrenamiento.meta?.entrTabaqRad
  );
  const [entrEstvidaRad, setEntrEstvidaRad] = useState(
    entrenamiento.meta?.entrEstvidaRad
  );
  const [entrObesidRad, setEntrObesidRad] = useState(
    entrenamiento.meta?.entrObesidRad
  );
  const [entrEnfermRad, setEntrEnfermRad] = useState(
    entrenamiento.meta?.entrEnfermRad
  );
  const [entrEnfermEsp, setEntrEnfermEsp] = useState(
    entrenamiento.meta?.entrEnfermEsp
  );
  const [entrDolorpechoRad, setEntrDolorpechoRad] = useState(
    entrenamiento.meta?.entrDolorpechoRad
  );
  const [entrDolorpechoEsp, setEntrDolorpechoEsp] = useState(
    entrenamiento.meta?.entrDolorpechoEsp
  );
  const [entrNoactpechoRad, setEntrNoactpechoRad] = useState(
    entrenamiento.meta?.entrNoactpechoRad
  );
  const [entrNoactpechoEsp, setEntrNoactpechoEsp] = useState(
    entrenamiento.meta?.entrNoactpechoEsp
  );
  const [entrMareosRad, setEntrMareosRad] = useState(
    entrenamiento.meta?.entrMareosRad
  );
  const [entrMareosEsp, setEntrMareosEsp] = useState(
    entrenamiento.meta?.entrMareosEsp
  );
  const [entrProbarticRad, setEntrProbarticRad] = useState(
    entrenamiento.meta?.entrProbarticRad
  );
  const [entrProbarticEsp, setEntrProbarticEsp] = useState(
    entrenamiento.meta?.entrProbarticEsp
  );
  const [entrFarmcardRad, setEntrFarmcardRad] = useState(
    entrenamiento.meta?.entrFarmcardRad
  );
  const [entrFarmcardEsp, setEntrFarmcardEsp] = useState(
    entrenamiento.meta?.entrFarmcardEsp
  );
  const [entrRaznoactRad, setEntrRaznoactRad] = useState(
    entrenamiento.meta?.entrRaznoactRad
  );
  const [entrRaznoactEsp, setEntrRaznoactEsp] = useState(
    entrenamiento.meta?.entrRaznoactEsp
  );
  const [entrConcl, setEntrConcl] = useState(entrenamiento.meta?.entrConcl);
  const [entrTrabactfis, setEntrTrabactfis] = useState(
    entrenamiento.meta?.entrTrabactfis
  );
  const [entrTrabactfisEsp, setEntrTrabactfisEsp] = useState(
    entrenamiento.meta?.entrTrabactfisEsp
  );
  const [entrTiempocio, setEntrTiempocio] = useState(
    entrenamiento.meta?.entrTrabactfis
  );
  const [entrTiempocioEsp, setEntrTiempocioEsp] = useState(
    entrenamiento.meta?.entrTrabactfisEsp
  );
  const [entrTipoejercsem, setEntrTipoejercsem] = useState(
    entrenamiento.meta?.entrTipoejercsem
  );
  const [entrTipoejercmes, setEntrTipoejercmes] = useState(
    entrenamiento.meta?.entrTipoejercmes
  );
  const [entrTipoejercano, setEntrTipoejercano] = useState(
    entrenamiento.meta?.entrTipoejercano
  );
  const [entrPercejerc, setEntrPercejerc] = useState(
    entrenamiento.meta?.entrPercejerc
  );

  const [entrEjercnegRad, setEntrEjercnegRad] = useState(
    entrenamiento.meta?.entrEjercnegRad
  );
  const [entrEjercnegEsp, setEntrEjercnegEsp] = useState(
    entrenamiento.meta?.entrEjercnegEsp
  );

  const [entrProgactfisRad, setEntrProgactfisRad] = useState(
    entrenamiento.meta?.entrProgactfisRad
  );
  const [entrProgactfisEsp, setEntrProgactfisEsp] = useState(
    entrenamiento.meta?.entrProgactfisEsp
  );
  const [entrActmasgust, setEntrActmasgust] = useState(
    entrenamiento.meta?.entrActmasgust
  );

  const [entrProgactfisconseg, setEntrProgactfisconseg] = useState(
    entrenamiento.meta?.entrProgactfisconseg
  );
  const [entrProgactfisdedic, setEntrProgactfisdedic] = useState(
    entrenamiento.meta?.entrProgactfisdedic
  );
  const [entrEjercultsem, setEntrEjercultsem] = useState(
    entrenamiento.meta?.entrEjercultsem
  );
  const [entrEjercvezsem, setEntrEjercvezsem] = useState(
    entrenamiento.meta?.entrEjercvezsem
  );
  const [entrEjercpract, setEntrEjercpract] = useState(
    entrenamiento.meta?.entrEjercpract
  );
  const [entrEjercintens, setEntrEjercintens] = useState(
    entrenamiento.meta?.entrEjercintens
  );
  const [entrEjercpercep, setEntrEjercpercep] = useState(
    entrenamiento.meta?.entrEjercpercep
  );
  const [entrObs, setEntrObs] = useState(entrenamiento.meta?.entrObs);

  const [entrEstado, setEntrEstado] = useState(entrenamiento.meta?.entrEstado ||'seguimiento');

  let { tratamientoId } = useParams();
  let { pacienteId } = useParams();
  let entrenamientoId = entrenamiento.id;

  const entrDate = new Date(entrenamiento.date);
  const diffDate = Math.abs(new Date() - entrDate) / 36e5;

  const submitEntrenamiento = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    try {
      await EntrenamientoUpdate(
        entrResp,
        entrFecha,
        entrNumses,
        entrMedio,
        entrHipertenRad,
        entrHiperlidRad,
        entrHiperglucRad,
        entrHistfamRad,
        entrTabaqRad,
        entrEstvidaRad,
        entrObesidRad,
        entrEnfermRad,
        entrEnfermEsp,
        entrDolorpechoRad,
        entrDolorpechoEsp,
        entrNoactpechoRad,
        entrNoactpechoEsp,
        entrMareosRad,
        entrMareosEsp,
        entrProbarticRad,
        entrProbarticEsp,
        entrFarmcardRad,
        entrFarmcardEsp,
        entrRaznoactRad,
        entrRaznoactEsp,
        entrConcl,
        entrTrabactfis,
        entrTrabactfisEsp,
        entrTiempocio,
        entrTiempocioEsp,
        entrTipoejercsem,
        entrTipoejercmes,
        entrTipoejercano,
        entrPercejerc,
        entrEjercnegRad,
        entrEjercnegEsp,
        entrProgactfisRad,
        entrProgactfisEsp,
        entrActmasgust,
        entrProgactfisconseg,
        entrProgactfisdedic,
        entrEjercultsem,
        entrEjercvezsem,
        entrEjercpract,
        entrEjercintens,
        entrEjercpercep,
        entrObs,
        entrEstado,
        tratamientoId,
        pacienteId,
        entrenamientoId
      ).then(
        (val) => {
          navigate(
            `../${tratamientoId}/seguimiento/entrenamiento/${entrenamientoId}`
          );
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  const deleteItem = async (e) => {
    e.preventDefault();
    setIsDeletingButton(true);
    try {
      await EntrenamientoDelete(entrenamientoId).then(
        (val) => {
          window.location.replace("../");
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id='content'>
        {entrenamiento.length === 0 ? (
          <div>Cargando...</div>
        ) : errorMessage ? (
          <p>{errorMessage}</p>
        ) : (
          <form id='formUpdatelement' onSubmit={submitEntrenamiento}>
            <fieldset id='disabledContainer'>
              {entrNumses === 1 ? <h3>Datos visita</h3> : <></>}
              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='entrResp'>Responsable</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='entrResp'
                      required
                      type='text'
                      value={entrResp}
                      onChange={(e) => setEntrResp(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='entrFecha'>Fecha visita</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='entrFecha'
                      required
                      type='date'
                      value={entrFecha}
                      onChange={(e) => setEntrFecha(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='entrNumses'>Número de sesión</label>
                  <div className='control'>
                    {props.userRole.includes('administrador') ? (
                      <input
                        className='input'
                        id='entrNumses'
                        required
                        type='number'
                        value={entrNumses}
                        onChange={(e) => setEntrNumses(e.target.value)}
                      />
                    ) : (
                      <input
                        className='input'
                        id='entrNumses'
                        required
                        disabled
                        type='number'
                        value={entrNumses}
                        onChange={(e) => setEntrNumses(e.target.value)}
                      />
                    )}
                  </div>
                </div>

                <div className='field'>
                  <label htmlFor='entrMedio'>Medio</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='entrMedio'
                        required
                        name='entrMedio'
                        value={entrMedio}
                        onChange={(e) => setEntrMedio(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='presencial'>Presencial</option>
                        <option value='videoconferencia'>
                          Videoconferencia
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                {(props.userRole.includes('administrador')) && (
                <div className='field'>
                  <label htmlFor='entrEstado'>Estado de seguimiento</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='entrEstado'
                        name='entrEstado'
                        value={entrEstado}
                        onChange={(e) => setEntrEstado(e.target.value)}
                      >
                        { OpcionesEstadosTratamientos.map((option) => (
                          <option
                            key={option.value}
                            value={option.value}
                            disabled={option.disabled}
                          >
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                )}
              </div>
              {entrNumses === 1 ? (
                <>
                  <h3>Evaluación de factores de riesgo CV</h3>
                  <div className='grid--2col'>
                    <div
                      className='field key'
                      data-key={entrHipertenRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>Hipertensión</label>
                        <label className='radio' htmlFor='entrHipertenRadSi'>
                          <input
                            id='entrHipertenRadSi'
                            name='entrHipertenRad'
                            type='radio'
                            value='Si'
                            checked={entrHipertenRad === "Si"}
                            onChange={(e) => setEntrHipertenRad(e.target.value)}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrHipertenRadNo'>
                          <input
                            id='entrHipertenRadNo'
                            name='entrHipertenRad'
                            type='radio'
                            value='No'
                            checked={entrHipertenRad === "No"}
                            onChange={(e) => setEntrHipertenRad(e.target.value)}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div
                      className='field key'
                      data-key={entrHiperlidRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>Hiperlipidemia</label>
                        <label className='radio' htmlFor='entrHiperlidRadSi'>
                          <input
                            id='entrHiperlidRadSi'
                            name='entrHiperlidRad'
                            type='radio'
                            value='Si'
                            checked={entrHiperlidRad === "Si"}
                            onChange={(e) => setEntrHiperlidRad(e.target.value)}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrHiperlidRadNo'>
                          <input
                            id='entrHiperlidRadNo'
                            name='entrHiperlidRad'
                            type='radio'
                            value='No'
                            checked={entrHiperlidRad === "No"}
                            onChange={(e) => setEntrHiperlidRad(e.target.value)}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div
                      className='field key'
                      data-key={entrHiperglucRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>Hiperglucemia</label>
                        <label className='radio' htmlFor='entrHiperglucRadSi'>
                          <input
                            id='entrHiperglucRadSi'
                            name='entrHiperglucRad'
                            type='radio'
                            value='Si'
                            checked={entrHiperglucRad === "Si"}
                            onChange={(e) =>
                              setEntrHiperglucRad(e.target.value)
                            }
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrHiperglucRadNo'>
                          <input
                            id='entrHiperglucRadNo'
                            name='entrHiperglucRad'
                            type='radio'
                            value='No'
                            checked={entrHiperglucRad === "No"}
                            onChange={(e) =>
                              setEntrHiperglucRad(e.target.value)
                            }
                          />
                          No
                        </label>
                      </div>
                    </div>

                    <div
                      className='field key'
                      data-key={entrHistfamRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>
                          Historial familiar
                        </label>
                        <label className='radio' htmlFor='entrHistfamRadSi'>
                          <input
                            id='entrHistfamRadSi'
                            name='entrHistfamRad'
                            type='radio'
                            value='Si'
                            checked={entrHistfamRad === "Si"}
                            onChange={(e) => setEntrHistfamRad(e.target.value)}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrHistfamRadNo'>
                          <input
                            id='entrHistfamRadNo'
                            name='entrHistfamRad'
                            type='radio'
                            value='No'
                            checked={entrHistfamRad === "No"}
                            onChange={(e) => setEntrHistfamRad(e.target.value)}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div
                      className='field key'
                      data-key={entrTabaqRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>Tabaquismo</label>
                        <label className='radio' htmlFor='entrTabaqRadSi'>
                          <input
                            id='entrTabaqRadSi'
                            name='entrTabaqRad'
                            type='radio'
                            value='Si'
                            checked={entrTabaqRad === "Si"}
                            onChange={(e) => setEntrTabaqRad(e.target.value)}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrTabaqRadNo'>
                          <input
                            id='entrTabaqRadNo'
                            name='entrTabaqRad'
                            type='radio'
                            value='No'
                            checked={entrTabaqRad === "No"}
                            onChange={(e) => setEntrTabaqRad(e.target.value)}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div
                      className='field key'
                      data-key={entrEstvidaRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>Estilo vida</label>
                        <label className='radio' htmlFor='entrEstvidaRadSi'>
                          <input
                            id='entrEstvidaRadSi'
                            name='entrEstvidaRad'
                            type='radio'
                            value='Si'
                            checked={entrEstvidaRad === "Si"}
                            onChange={(e) => setEntrEstvidaRad(e.target.value)}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrEstvidaRadNo'>
                          <input
                            id='entrEstvidaRadNo'
                            name='entrEstvidaRad'
                            type='radio'
                            value='No'
                            checked={entrEstvidaRad === "No"}
                            onChange={(e) => setEntrEstvidaRad(e.target.value)}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div
                      className='field key'
                      data-key={entrObesidRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>Obesidad</label>
                        <label className='radio' htmlFor='entrObesidRadSi'>
                          <input
                            id='entrObesidRadSi'
                            name='entrObesidRad'
                            type='radio'
                            value='Si'
                            checked={entrObesidRad === "Si"}
                            onChange={(e) => setEntrObesidRad(e.target.value)}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrObesidRadNo'>
                          <input
                            id='entrObesidRadNo'
                            name='entrObesidRad'
                            type='radio'
                            value='No'
                            checked={entrObesidRad === "No"}
                            onChange={(e) => setEntrObesidRad(e.target.value)}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div
                      className='field key'
                      data-key={entrEnfermRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>
                          ¿Le ha dicho el médico alguna vez que padece una
                          enfermedad y que solo debe hacer actividad física que
                          le aconseje un médico?
                        </label>
                        <label className='radio' htmlFor='entrEnfermRadSi'>
                          <input
                            id='entrEnfermRadSi'
                            name='entrEnfermRad'
                            type='radio'
                            value='Si'
                            checked={entrEnfermRad === "Si"}
                            onChange={(e) => setEntrEnfermRad(e.target.value)}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrEnfermRadNo'>
                          <input
                            id='entrEnfermRadNo'
                            name='entrEnfermRad'
                            type='radio'
                            value='No'
                            checked={entrEnfermRad === "No"}
                            onChange={(e) => setEntrEnfermRad(e.target.value)}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div className='field lock'>
                      <label htmlFor='entrEnfermEsp'>
                        Enfermedad - Especificar
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrEnfermEsp'
                          type='text'
                          value={entrEnfermEsp}
                          onChange={(e) => setEntrEnfermEsp(e.target.value)}
                        />
                      </div>
                    </div>
                    <div
                      className='field key'
                      data-key={entrDolorpechoRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>
                          ¿Tiene dolor o molestias en el pecho cuando hace
                          actividad física?
                        </label>
                        <label className='radio' htmlFor='entrDolorpechoRadSi'>
                          <input
                            id='entrDolorpechoRadSi'
                            name='entrDolorpechoRad'
                            type='radio'
                            value='Si'
                            checked={entrDolorpechoRad === "Si"}
                            onChange={(e) =>
                              setEntrDolorpechoRad(e.target.value)
                            }
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrDolorpechoRadNo'>
                          <input
                            id='entrDolorpechoRadNo'
                            name='entrDolorpechoRad'
                            type='radio'
                            value='No'
                            checked={entrDolorpechoRad === "No"}
                            onChange={(e) =>
                              setEntrDolorpechoRad(e.target.value)
                            }
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div className='field lock'>
                      <label htmlFor='entrDolorpechoEsp'>
                        Molestias - Especificar
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrDolorpechoEsp'
                          type='text'
                          value={entrDolorpechoEsp}
                          onChange={(e) => setEntrDolorpechoEsp(e.target.value)}
                        />
                      </div>
                    </div>
                    <div
                      className='field key'
                      data-key={entrNoactpechoRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>
                          En el último mes ¿ha tenido dolor en el pecho cuando
                          no hacía actividad física?
                        </label>
                        <label className='radio' htmlFor='entrNoactpechoRadSi'>
                          <input
                            id='entrNoactpechoRadSi'
                            name='entrNoactpechoRad'
                            type='radio'
                            value='Si'
                            checked={entrNoactpechoRad === "Si"}
                            onChange={(e) =>
                              setEntrNoactpechoRad(e.target.value)
                            }
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrNoactpechoRadNo'>
                          <input
                            id='entrNoactpechoRadNo'
                            name='entrNoactpechoRad'
                            type='radio'
                            value='No'
                            checked={entrNoactpechoRad === "No"}
                            onChange={(e) =>
                              setEntrNoactpechoRad(e.target.value)
                            }
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div className='field lock'>
                      <label htmlFor='entrNoactpechoEsp'>
                        Dolor en el pecho - Especificar
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrNoactpechoEsp'
                          type='text'
                          value={entrNoactpechoEsp}
                          onChange={(e) => setEntrNoactpechoEsp(e.target.value)}
                        />
                      </div>
                    </div>
                    <div
                      className='field key'
                      data-key={entrMareosRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>
                          ¿Pierde el equilibrio debido a mareos o se ha
                          desmayado alguna vez?
                        </label>
                        <label className='radio' htmlFor='entrMareosRadSi'>
                          <input
                            id='entrMareosRadSi'
                            name='entrMareosRad'
                            type='radio'
                            value='Si'
                            checked={entrMareosRad === "Si"}
                            onChange={(e) => setEntrMareosRad(e.target.value)}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrMareosRadNo'>
                          <input
                            id='entrMareosRadNo'
                            name='entrMareosRad'
                            type='radio'
                            value='No'
                            checked={entrMareosRad === "No"}
                            onChange={(e) => setEntrMareosRad(e.target.value)}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div className='field lock'>
                      <label htmlFor='entrMareosEsp'>
                        Equilibrio - Especificar
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrMareosEsp'
                          type='text'
                          value={entrMareosEsp}
                          onChange={(e) => setEntrMareosEsp(e.target.value)}
                        />
                      </div>
                    </div>
                    <div
                      className='field key'
                      data-key={entrProbarticRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>
                          ¿Tiene problema de huesos o articulaciones (espalda,
                          rodillas o cadera) que puedan empeorar si aumenta la
                          actividad física?
                        </label>
                        <label className='radio' htmlFor='entrProbarticRadSi'>
                          <input
                            id='entrProbarticRadSi'
                            name='entrProbarticRad'
                            type='radio'
                            value='Si'
                            checked={entrProbarticRad === "Si"}
                            onChange={(e) =>
                              setEntrProbarticRad(e.target.value)
                            }
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrProbarticRadNo'>
                          <input
                            id='entrProbarticRadNo'
                            name='entrProbarticRad'
                            type='radio'
                            value='No'
                            checked={entrProbarticRad === "No"}
                            onChange={(e) =>
                              setEntrProbarticRad(e.target.value)
                            }
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div className='field lock'>
                      <label htmlFor='entrProbarticEsp'>
                        Articulaciones - Especificar
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrProbarticEsp'
                          type='text'
                          value={entrProbarticEsp}
                          onChange={(e) => setEntrProbarticEsp(e.target.value)}
                        />
                      </div>
                    </div>
                    <div
                      className='field key'
                      data-key={entrFarmcardRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>
                          ¿Le receta su médico algún fármaco para la tensión
                          arterial o problema cardiaco?
                        </label>
                        <label className='radio' htmlFor='entrFarmcardRadSi'>
                          <input
                            id='entrFarmcardRadSi'
                            name='entrFarmcardRad'
                            type='radio'
                            value='Si'
                            checked={entrFarmcardRad === "Si"}
                            onChange={(e) => setEntrFarmcardRad(e.target.value)}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrFarmcardRadNo'>
                          <input
                            id='entrFarmcardRadNo'
                            name='entrFarmcardRad'
                            type='radio'
                            value='No'
                            checked={entrFarmcardRad === "No"}
                            onChange={(e) => setEntrFarmcardRad(e.target.value)}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div className='field lock'>
                      <label htmlFor='entrFarmcardEsp'>
                        Especificar Fármaco
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrFarmcardEsp'
                          type='text'
                          value={entrFarmcardEsp}
                          onChange={(e) => setEntrFarmcardEsp(e.target.value)}
                        />
                      </div>
                    </div>
                    <div
                      className='field key'
                      data-key={entrRaznoactRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>
                          ¿Conoce alguna razón por la que no podría hacer
                          actividad física?
                        </label>
                        <label className='radio' htmlFor='entrRaznoactRadSi'>
                          <input
                            id='entrRaznoactRadSi'
                            name='entrRaznoactRad'
                            type='radio'
                            value='Si'
                            checked={entrRaznoactRad === "Si"}
                            onChange={(e) => setEntrRaznoactRad(e.target.value)}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrRaznoactRadNo'>
                          <input
                            id='entrRaznoactRadNo'
                            name='entrRaznoactRad'
                            type='radio'
                            value='No'
                            checked={entrRaznoactRad === "No"}
                            onChange={(e) => setEntrRaznoactRad(e.target.value)}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div className='field lock'>
                      <label htmlFor='entrRaznoactEsp'>
                        Razón - Especificar
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrRaznoactEsp'
                          type='text'
                          value={entrRaznoactEsp}
                          onChange={(e) => setEntrRaznoactEsp(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className='field'>
                      <label htmlFor='entrConcl'>Conclusiones</label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='entrConcl'
                            required
                            name='entrConcl'
                            value={entrConcl}
                            onChange={(e) => setEntrConcl(e.target.value)}
                          >
                            <option disabled value=''>
                              -- Selecciona una opción --
                            </option>
                            <option value='si-espec'>
                              Sí debería realizar un chequeo con un especialista
                            </option>
                            <option value='no-espec'>
                              No es necesario chequeo con un especialista
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <h3>Realización de actividad física</h3>
                  <div className='grid--2col'>
                    <div
                      className='field key'
                      data-key={entrTrabactfis?.toString()}
                    >
                      <label htmlFor='entrTrabactfis'>
                        En el trabajo - ¿Realiza una actividad física?
                      </label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='entrTrabactfis'
                            required
                            name='entrTrabactfis'
                            value={entrTrabactfis}
                            onChange={(e) => setEntrTrabactfis(e.target.value)}
                          >
                            <option disabled value=''>
                              -- Selecciona una opción --
                            </option>
                            <option value='si-intens'>Intensa</option>
                            <option value='si-moder'>Moderada</option>
                            <option value='sedent'>Sedentaria</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='field lock'>
                      <label htmlFor='entrTrabactfisEsp'>
                        En el trabajo - ¿Desde cuándo realiza dicha actividad?
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrTrabactfisEsp'
                          type='text'
                          value={entrTrabactfisEsp}
                          onChange={(e) => setEntrTrabactfisEsp(e.target.value)}
                        />
                      </div>
                    </div>

                    <div
                      className='field key'
                      data-key={entrTiempocio?.toString()}
                    >
                      <label htmlFor='entrTiempocio'>
                        ¿En su tiempo de ocio ha realizado o realiza ejercicio?
                      </label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='entrTiempocio'
                            required
                            name='entrTiempocio'
                            value={entrTiempocio}
                            onChange={(e) => setEntrTiempocio(e.target.value)}
                          >
                            <option disabled value=''>
                              -- Selecciona una opción --
                            </option>
                            <option value='pasad'>Sí, en el pasado</option>
                            <option value='si-actual'>Sí, actualmente</option>
                            <option value='si-pasad-actual'>
                              Sí, en el pasado y actualmente
                            </option>
                            <option value='no'>No</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='field lock'>
                      <label htmlFor='entrTiempocioEsp'>
                        Especificar frecuencia ejercicio
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrTiempocioEsp'
                          type='text'
                          value={entrTiempocioEsp}
                          onChange={(e) => setEntrTiempocioEsp(e.target.value)}
                        />
                      </div>
                    </div>

                    {/* <div
                      className='field key'
                      data-key={entrOcioejerc?.toString()}
                    >
                      <label htmlFor='entrOcioejerc'>
                        ¿En su tiempo de ocio ha realizado o realiza ejercicio?
                      </label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='entrOcioejerc'
                            required
                            name='entrOcioejerc'
                            value={entrOcioejerc}
                            onChange={(e) => setEntrOcioejerc(e.target.value)}
                          >
                            <option disabled value=''>
                              -- Selecciona una opción --
                            </option>
                            <option value='pasad'>Sí, en el pasado</option>
                            <option value='si-actual'>Sí, actualmente</option>
                            <option value='si-pasad-actual'>
                              Sí, en el pasado y actualmente
                            </option>
                            <option value='no'>No</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='field lock'>
                      <label htmlFor='entrOcioejercEsp'>
                        Especificar frecuencia ejercicio
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrOcioejercEsp'
                          type='text'
                          required
                          value={entrOcioejercEsp}
                          onChange={(e) => setEntrOcioejercEsp(e.target.value)}
                        />
                      </div>
                    </div> */}

                    <div className='field'>
                      <label htmlFor='entrTipoejercsem'>
                        Tipo(s) de ejercicio habitual en la última semana
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrTipoejercsem'
                          type='text'
                          required
                          value={entrTipoejercsem}
                          onChange={(e) => setEntrTipoejercsem(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='entrTipoejercmes'>
                        Tipo(s) de ejercicio habitual en el último mes
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrTipoejercmes'
                          type='text'
                          required
                          value={entrTipoejercmes}
                          onChange={(e) => setEntrTipoejercmes(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='entrTipoejercano'>
                        Tipo(s) de ejercicio habitual en el último año
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrTipoejercano'
                          type='text'
                          required
                          value={entrTipoejercano}
                          onChange={(e) => setEntrTipoejercano(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='entrPercejerc'>
                        Percepción del ejercicio
                      </label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='entrPercejerc'
                            required
                            name='entrPercejerc'
                            value={entrPercejerc}
                            onChange={(e) => setEntrPercejerc(e.target.value)}
                          >
                            <option disabled value=''>
                              -- Selecciona una opción --
                            </option>
                            <option value='cansa'>Cansa</option>
                            <option value='tensa'>Tensa</option>
                            <option value='relaja'>Relaja</option>
                            <option value='tonifica'>Tonifica</option>
                            <option value='sienta-bien'>Sienta bien</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='grid--2col'>
                    <div
                      className='field key'
                      data-key={entrEjercnegRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>
                          ¿Tiene o ha tenido alguna sensación negativa hacia el
                          ejercicio?
                        </label>
                        <label className='radio' htmlFor='entrEjercnegRadSi'>
                          <input
                            id='entrEjercnegRadSi'
                            name='entrEjercnegRad'
                            type='radio'
                            value='Si'
                            checked={entrEjercnegRad === "Si"}
                            onChange={(e) => setEntrEjercnegRad(e.target.value)}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrEjercnegRadNo'>
                          <input
                            id='entrEjercnegRadNo'
                            name='entrEjercnegRad'
                            type='radio'
                            value='No'
                            checked={entrEjercnegRad === "No"}
                            onChange={(e) => setEntrEjercnegRad(e.target.value)}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div className='field lock'>
                      <label htmlFor='entrEjercnegEsp'>
                        Sensación Negativa - Especificar
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrEjercnegEsp'
                          type='text'
                          value={entrEjercnegEsp}
                          onChange={(e) => setEntrEjercnegEsp(e.target.value)}
                        />
                      </div>
                    </div>

                    <div
                      className='field key'
                      data-key={entrProgactfisRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>
                          ¿Le cuesta ser constante en programas de actividad
                          física?
                        </label>
                        <label className='radio' htmlFor='entrProgactfisRadSi'>
                          <input
                            id='entrProgactfisRadSi'
                            name='entrProgactfisRad'
                            type='radio'
                            value='Si'
                            checked={entrProgactfisRad === "Si"}
                            onChange={(e) =>
                              setEntrProgactfisRad(e.target.value)
                            }
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrProgactfisRadNo'>
                          <input
                            id='entrProgactfisRadNo'
                            name='entrProgactfisRad'
                            type='radio'
                            value='No'
                            checked={entrProgactfisRad === "No"}
                            onChange={(e) =>
                              setEntrProgactfisRad(e.target.value)
                            }
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div className='field lock'>
                      <label htmlFor='entrProgactfisEsp'>
                        Constante - Especificar
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrProgactfisEsp'
                          type='text'
                          value={entrProgactfisEsp}
                          onChange={(e) => setEntrProgactfisEsp(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='entrActmasgust'>
                        ¿Qué tipo de actividades físicas le gusta más realizar?
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrActmasgust'
                          type='text'
                          required
                          value={entrActmasgust}
                          onChange={(e) => setEntrActmasgust(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className='field'>
                      <label htmlFor='entrProgactfisconseg'>
                        ¿Qué te gustaría conseguir con un programa de actividad
                        física?
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrProgactfisconseg'
                          type='text'
                          required
                          value={entrProgactfisconseg}
                          onChange={(e) =>
                            setEntrProgactfisconseg(e.target.value)
                          }
                        />
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='entrProgactfisdedic'>
                        ¿Qué dedicación podría dedicarle al programa de
                        actividad física?
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrProgactfisdedic'
                          type='text'
                          required
                          value={entrProgactfisdedic}
                          onChange={(e) =>
                            setEntrProgactfisdedic(e.target.value)
                          }
                        />
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                // Here start 'Sesiones Seguimiento'
                <div className='grid--2col'>
                  <div className='field'>
                    <label htmlFor='entrEjercultsem'>
                      ¿Cuántas veces has hecho ejercicio en la última semana?
                    </label>
                    <div className='control'>
                      <div className='select'>
                        <select
                          className='select'
                          id='entrEjercultsem'
                          required
                          name='entrEjercultsem'
                          value={entrEjercultsem}
                          onChange={(e) => setEntrEjercultsem(e.target.value)}
                        >
                          <option disabled value=''>
                            -- Selecciona una opción --
                          </option>
                          <option value='nada'>Nada</option>
                          <option value='una-dos'>1-2 veces</option>
                          <option value='tres-cuatro'>3-4 veces</option>
                          <option value='cinco-siete'>5-7 veces</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className='field'>
                    <label htmlFor='entrEjercvezsem'>
                      ¿Cuánto tiempo has hecho ejercicio cada vez por semana?
                    </label>
                    <div className='control'>
                      <div className='select'>
                        <select
                          className='select'
                          id='entrEjercvezsem'
                          required
                          name='entrEjercvezsem'
                          value={entrEjercvezsem}
                          onChange={(e) => setEntrEjercvezsem(e.target.value)}
                        >
                          <option disabled value=''>
                            -- Selecciona una opción --
                          </option>
                          <option value='nada'>Nada</option>
                          <option value='menos-una-h'>Menos de 1 hora</option>
                          <option value='una-h'>1 hora</option>
                          <option value='mas-una-h'>Más de 1 hora</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className='field'>
                    <label htmlFor='entrEjercpract'>
                      ¿Qué deporte o ejercicio has practicado?
                    </label>
                    <div className='control'>
                      <input
                        className='input'
                        id='entrEjercpract'
                        type='text'
                        required
                        value={entrEjercpract}
                        onChange={(e) => setEntrEjercpract(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className='field'>
                    <label htmlFor='entrEjercintens'>
                      Percepción del grado de intensidad del ejercicio
                    </label>
                    <div className='control'>
                      <div className='select'>
                        <select
                          className='select'
                          id='entrEjercintens'
                          required
                          name='entrEjercintens'
                          value={entrEjercintens}
                          onChange={(e) => setEntrEjercintens(e.target.value)}
                        >
                          <option disabled value=''>
                            -- Selecciona una opción --
                          </option>
                          <option value='uno'>1 - Poco o nada intenso</option>
                          <option value='dos'>2</option>
                          <option value='tres'>3</option>
                          <option value='cuatro'>4</option>
                          <option value='cinco'>5 - Tolerable</option>
                          <option value='seis'>6</option>
                          <option value='siete'>7</option>
                          <option value='ocho'>8</option>
                          <option value='nueve'>9</option>
                          <option value='diez'>10 - Extenuante</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className='field'>
                    <label htmlFor='entrEjercpercep'>
                      Percepción del ejercicio
                    </label>
                    <div className='control'>
                      <div className='select'>
                        <select
                          className='select'
                          id='entrEjercpercep'
                          required
                          name='entrEjercpercep'
                          value={entrEjercpercep}
                          onChange={(e) => setEntrEjercpercep(e.target.value)}
                        >
                          <option disabled value=''>
                            -- Selecciona una opción --
                          </option>
                          <option value='cansa'>Cansa</option>
                          <option value='tensa'>Tensa</option>
                          <option value='relaja'>Relaja</option>
                          <option value='tonifica'>Tonifica</option>
                          <option value='sienta-bien'>Sienta bien</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className='field'>
                <label className='' htmlFor='entrObs'>
                  Observaciones
                </label>
                <div className='control'>
                  <textarea
                    className='textarea'
                    name='entrObs'
                    id='entrObs'
                    value={entrObs}
                    onChange={(e) => setEntrObs(e.target.value)}
                  ></textarea>
                </div>
              </div>
            </fieldset>
          </form>
        )}
      </div>
      {!errorMessage && (
        <div id='actions'>
          {(diffDate <= 72 || props.userRole.includes('administrador')) && (
            <button
              className='button is-link'
              id='saveButton'
              form='formUpdatelement'
              type='submit'
              disabled={isCreatingButton}
            >
              {isCreatingButton ? <div className="spinner"></div> : 'Guardar'}
            </button>
          )}
          <Link
            className='button is-link is-light'
            to={`../${tratamientoId}/seguimiento/entrenamiento/${entrenamiento.id}`}
          >
            Cancelar
          </Link>
          {props.userRole.includes('administrador') && (
            <button
              className='button is-danger'
              id='deleteButton'
              onClick={deleteItem}
              disabled={isDeletingButton}
            >
              {isDeletingButton ? <div className="spinner"></div> : 'Eliminar'}
            </button>
          )}
        </div>
      )}
    </>
  );
}
